<template>
	<div>
		<v-layout justify-center>
			<v-flex xs12 sm12 md12 lg12>
				<v-container>
					<v-row no-gutters v-if="eventClass.id === 'kids-camps'">
						<v-col xs="12" sm="9" md="9">
							<p class="pa-4">{{ about }}</p>
						</v-col>
						<v-col xs="12" sm="3" md="3">
							<div class="pa-4 ">
								<h4
									style="text-align: center; border-bottom: 1px solid black;"
									class="pa-1"
								>
									{{ classorevent }} Price
								</h4>
								<ul v-for="c in eventClass.prices" :key="c">
									<li class="pa-1">
										{{ c }}
									</li>
								</ul>
							</div>
						</v-col>
					</v-row>
					<v-row no-gutters v-if="eventClass.id !== 'kids-camps'">
						<v-col xs="12" sm="12" md="12">
							<p style="text-align:center" class="pa-4">{{ about }}</p>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col xs="12" sm="12" md="12">
							<v-img aspect-ratio="1.7" :src="this.mainImg"></v-img>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col v-for="img in images" :key="img" xs="2" sm="2" md="2">
							<v-img
								aspect-ratio="1.7"
								:src="img"
								v-on:mouseover="onPhotoChange(img)"
							></v-img>
						</v-col>
					</v-row>
				</v-container>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
//import fb from '@/fb'
export default {
	props: {
		about: {
			type: String,
			required: true,
		},
		eventName: {
			type: String,
			required: true,
		},
		images: {
			type: Array,
			required: true,
		},
		classorevent: {
			type: String,
			required: true,
		},
		eventClass: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			mainImg: [],
			router: "/" + this.classorevent,
		};
	},
	watch: {
		// whenever question changes, this function will run
		images(newImages, oldImages) {
			if (newImages !== oldImages) {
				this.mainImg = newImages ? newImages[0] : "";
			}
		},
	},
	methods: {
		onPhotoChange: function(img) {
			this.mainImg = img;
		},
	},
	created() {
		this.mainImg = this.$props.images ? this.$props.images[0] : "";
	},
};
</script>
